import React from 'react';
import CustomTextField from '../../../Formik/TextField';

const TextField = props => {
  return <CustomTextField removeUnnecessaryWhitespaces {...props} />;
};

export default TextField;
